<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <nz-card>
      <div class="查询区">
        <!-- <div>
        <span class="relative" (click)="isShowCondition = !isShowCondition">
          <span class="to-top" [ngClass]="{ 'translate-180': !isShowCondition }"></span>
        </span>
        <strong class="black-title" style="margin-left: 18px">{{ "Condition" | translate}}</strong>
      </div> -->
        <div class="查询条件">
          <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm($event, validateForm.value)">
            <!-- 第一行 -->
            <div nz-row>
              <div nz-col nzSpan="4">
                <nz-form-label nzSpan="16" nzRequired>
                  <div class="width-100-percent label-font">{{ "StoreField" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="16">
                    <nz-select style="width: 240px;" formControlName="StoreField" nzAllowClear>
                      <nz-option nzLabel="{{'Integrity'|translate}}" nzValue="Integrity"></nz-option>
                      <nz-option nzLabel="{{'Video'|translate}}" nzValue="Video"></nz-option>
                      <nz-option nzLabel="{{'Document'|translate}}" nzValue="Document"></nz-option>
                      <nz-option nzLabel="{{'AccountApplicationForm'|translate}}"nzValue="AccountApplicationForm"></nz-option>
                      <nz-option nzLabel="{{'DevelopmentFile'|translate}}" nzValue="DevelopmentFile"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col class="row-with-spacing-button">
                <button nz-button class="default-button" nzType="primary" (click)="onSearch()">
                  <span nz-icon nzType="search"></span>{{ "Query" | translate}}</button>
              </div>
              <div nz-col class="row-with-spacing-button">
                <button nz-button nzType="primary" class="default-button" (click)="UploadPage()">
                  <span nz-icon nzType="upload" nzTheme="outline"></span>{{'UploadExcel'|translate}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </nz-card>
    <nz-card style="margin-top: 10px;">
      <div>
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      </div>
      <div>
        <nz-modal [(nzVisible)]="ShowUploadPage" nzTitle="Upload" (nzOnCancel)="handleCancel()"
          [formGroup]="UploadvalidateForm" [nzFooter]="null" style="color: black;">
          <div *nzModalContent>
            <nz-form-item>
              <nz-form-label nzRequired>
                <div class="width-100-percent label-font" style="color: rgb(2, 0, 0);">{{'FileTarget'|translate}}
                </div>
              </nz-form-label>
              <nz-form-control>
                <nz-select style="width: 240px;" formControlName="FileTarget" nzAllowClear>
                  <nz-option nzLabel="{{'Integrity'|translate}}" nzValue="Integrity"></nz-option>
                  <nz-option nzLabel="{{'Video'|translate}}" nzValue="Video"></nz-option>
                  <nz-option nzLabel="{{'Document'|translate}}" nzValue="Document"></nz-option>
                  <nz-option nzLabel="{{'AccountApplicationForm'|translate}}"
                    nzValue="AccountApplicationForm"></nz-option>
                  \<nz-option nzLabel="{{'DevelopmentFile'|translate}}" nzValue="DevelopmentFile"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
            <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload" [nzMultiple]="true" style="margin-left: 450px;">
              <button nz-button class="upload-button default-button" [disabled]="!UploadvalidateForm.valid">
                <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
              </button>
            </nz-upload>

          </div>
        </nz-modal>
      </div>
      <div class="表格"  >

  <nz-table #colSpanTable [nzData]="listOfData" nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false" 
            [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex' 
            [nzScroll]="{ y: '500px' }">


          <thead>
            <tr>
              <th scope="col" style=" text-align: center;" nzWidth="50%">{{ "table.FileName" | translate}}</th>
              <th scope="col" style="text-align: center;" nzWidth="50%">{{ "act" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index" style="text-align: center;">
              <td>{{data.fileName}}</td>
              <td class="action-td">
                <img src="../../../assets/image/u282.png" class="pointer" style="margin-left: 4px;" alt="" nz-popover
                  [nzPopoverContent]="contentTemplate" nzPopoverPlacement="right" nzPopoverTrigger="click"
                  [nzPopoverVisible]="data.isShowAction" (click)="showAction($event,data)">
                <ng-template #contentTemplate>
                  <div class="action-box" >
                    <div>
                      <div class='action-div' (click)="onUpdate(data,true)">
                        <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpdate">
                          <span class="margin-left-8">{{'Update'|translate}}</span>
                        </nz-upload>
                      </div>
                    </div>
                    <div>
                      <div class='action-div' (click)="onDowmload(data)">
                        <span class="margin-left-8">{{'Dowmload'|translate}}</span>
                      </div>
                    </div>
                    <div>
                      <div class='action-div' (click)="onDelete(data,false)">
                        <span class="margin-left-8">{{'Delete'|translate}}</span>
                      </div>
                    </div>
                    <div>
                      <div class='action-div' (click)="onRename(data)">
                        <span class="margin-left-8">{{'Rename'|translate}}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <nz-modal [(nzVisible)]="ShowRenamePage" nzTitle="Rename" (nzOnCancel)="handleCancel()"
          [formGroup]="RenamevalidateForm" (nzOnCancel)="handleCancel()" 
          (nzOnOk)="RenameOK()" nzOkText="{{'Submit'|translate}}"  nzCancelText="{{'cancel'|translate}}">
          <div *nzModalContent>
            <nz-form-item>
              <nz-form-label nzRequired>
                <div class="width-100-percent label-font" style="color: rgb(0, 0, 0);">{{'Name'|translate}}
                </div>
              </nz-form-label>
              <nz-form-control>
                <nz-row>
                  <nz-col>
                    <input nz-input formControlName="Name" />
                  </nz-col>
                  <nz-col nzPush="1">
                    <div class="width-100-percent label-font" style="color: rgb(0, 0, 0);font-size: 16px;">
                      {{this.ActData.fileType}}</div>
                  </nz-col>
                </nz-row>
              </nz-form-control>
            </nz-form-item>
          </div>
          <!-- <div *nzModalFooter>
            <button nz-button nzType="primary" (click)="RenameOK()">Yes</button>
            <button nz-button nzType="default" (click)="handleCancel()">No</button>
          </div> -->
        </nz-modal>
      </div>
    </nz-card>
  </div>
</nz-spin>